const EMPLOYEES_LOGS_TABLE_HEADERS = ['name', 'id', 'email', 'hours'] as const;

const EmployeesLogsTableHeaderValues = [...EMPLOYEES_LOGS_TABLE_HEADERS];

export default EmployeesLogsTableHeaderValues;
